import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { SOCIAL_AUTH_CONFIG, SocialLoginModule } from '@abacritt/angularx-social-login';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { refreshTokenInterceptor } from './shared/interceptors/refresh-token.interceptor';
import { companyContextInterceptor } from './shared/interceptors/company-context.interceptor';
import { providePwa } from './shared/pwa';
import { OsobniLinkMetaService } from './shared/privatnost';
import { DrustvenaPrijava } from './shared/utils/drustvena-prijava.util';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    providePwa(),
    // Osobni link klijenta (/k/**): robots noindex i referrer no-referrer i pri SPA navigaciji.
    provideAppInitializer(() => inject(OsobniLinkMetaService).pokreni()),
    provideHttpClient(withInterceptors([refreshTokenInterceptor, authInterceptor, companyContextInterceptor])),
    importProvidersFrom(SocialLoginModule),
    {
      // Google i Facebook (uz App ID) — konfiguracija se razriješi tek na stranici prijave ili registracije
      // (`DrustvenaPrijava.ukljuci()`), pa se njihove skripte ne učitavaju na ostalim stranicama.
      provide: SOCIAL_AUTH_CONFIG,
      useFactory: () => inject(DrustvenaPrijava).konfiguracija,
    },
  ],
};
